import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-derm-child-widget',
  templateUrl: './derm-child-widget.component.html',
  styleUrls: ['./derm-child-widget.component.css']
})
export class DermChildWidgetComponent implements OnInit {
  @Input() provider;
  @Input() patient;
  @Input() childDerm;
  @Input() readOnlyMode : any;
  @Input() actualParentDerm;
  @Input() isPreview;
  mainImage: string;
  constructor() { }

  ngOnInit(): void {
    this.mainImage = this.childDerm.derm_images[0];
  }
  showWoundImagePreviewDialog(derm, imageIndex = 0) {

  }
  handleChildWoundClick(){
    
  }
}
